// @ts-nocheck
import { useCallback } from 'react';
import useEventListener from '@hooks/useEventListener';

function useOutsideClick(ref, handler) {
  if (!ref || !handler) return;

  const memoizedHandler = useCallback(
    event => {
      if (ref.current && !ref.current.contains(event.target)) handler();
    },
    [ref, handler],
  );

  useEventListener({ eventName: 'click', handler: memoizedHandler });
}

export default useOutsideClick;

/*
  useOutsideClick: Do something when a click is detected outside of an element
  ...
  const wrapperRef = useRef(null);
  const handleClickOutside = (event) => console.log('handling my event!', event)
  ...
  ...
  useOutsideClick(wrapperRef, handleClickOutside);
*/
